export default "__VITE_ASSET__Cf2g9KBz__"